import { useGlobal } from '@/utils/useGlobal';
import { useEffect } from 'react';
import styles from './index.module.scss';
import EcoVideo from 'eco-design/base/eco-video';
import EcoImg from 'eco-design/base/eco-img';

export default function K() {
    const { useLang } = useGlobal();
    const { t } = useLang('PowerOcean.K');

    useEffect(() => {
        const AniContainer = window?.AniContainer;
        const scene = AniContainer.create({
            asyncFromTo: [
                ['.power-ocean-home-K .pc .text1', { opacity: 1, y: 0 }, { opacity: 0, y: -300 }, 0.6],
                ['.power-ocean-home-K .pc .text2', { opacity: 0, y: 300 }, { opacity: 1, y: 0 }, 0.6],
                ['.power-ocean-home-K .pc .img-box', { opacity: 1, x: 0 }, { opacity: 1, x: 316 }, 0.15],
            ],
            asyncTimeLine: [0, 0.2, 0.2],
            triggerElement: '.power-ocean-home-K',
            triggerHook: 1,
            offset: '100%',
            duration: '100%',
            scrollUpdatePos: true,
        });
        const scene2 = AniContainer.create({
            triggerElement: '.power-ocean-home-K',
            triggerHook: 1,
            offset: '100%',
            scrollUpdatePos: true,
            onEnter: () => {
                const targetEl = document.querySelector('.power-ocean-home-K .pc video') as HTMLVideoElement;
                if (targetEl) {
                    targetEl.play();
                }
            },
            onLeave: () => {
                const targetEl = document.querySelector('.power-ocean-home-K .pc video') as HTMLVideoElement;
                if (targetEl) {
                    targetEl.pause();
                    targetEl.currentTime = 0;
                }
            },
        });
        return () => {
            scene.destroy();
            scene2.destroy();
        };
    }, []);

    useEffect(() => {
        const layoutW = typeof window !== 'undefined' ? window.innerWidth : 375;
        const AniContainer = window?.AniContainer;
        const scene = AniContainer.create({
            asyncFromTo: [
                ['.power-ocean-home-K .h5 .text1', { opacity: 1, y: 0 }, { opacity: 0, y: -0 }, 1],
                ['.power-ocean-home-K .h5 .text2', { opacity: 0, y: 0 }, { opacity: 1, y: 0 }, 1],
                ['.power-ocean-home-K .h5 .img-box', { opacity: 1, x: 0 }, { opacity: 1, x: (layoutW / 3.75) * 1.68 }, 0.25],
            ],
            asyncTimeLine: [0, 0.5, 0.5],
            triggerElement: '.power-ocean-home-K',
            triggerHook: 1,
            offset: '100%',
            duration: '100%',
            scrollUpdatePos: true,
        });

        const scene2 = AniContainer.create({
            triggerElement: '.power-ocean-home-K',
            triggerHook: 1,
            offset: '100%',
            scrollUpdatePos: true,
            onEnter: () => {
                const targetEl = document.querySelector('.power-ocean-home-K .h5 video') as HTMLVideoElement;
                if (targetEl) {
                    targetEl.play();
                }
            },
            onLeave: () => {
                const targetEl = document.querySelector('.power-ocean-home-K .h5 video') as HTMLVideoElement;
                if (targetEl) {
                    targetEl.pause();
                    targetEl.currentTime = 0;
                }
            },
        });
        return () => {
            scene.destroy();
            scene2.destroy();
        };
    }, []);

    return (
        <div className={`power-ocean-home-K ${styles['power-ocean-home-K']}`}>
            <div className="pc">
                <div className="sticky">
                    <div className="left-box">
                        <div className="text-box">
                            <div className="text1">
                                <h2 className="title">{t('title1')}</h2>
                                <p className="desc">{t('desc1')}</p>
                            </div>
                        </div>
                        <div className="text-box">
                            <div className="text2">
                                <h2 className="title">{t('title2')}</h2>
                                <p className="desc">{t('desc2')}</p>
                            </div>
                        </div>
                    </div>
                    <div className="right-box">
                        <div className="img-box">
                            <EcoImg
                                pc="https://websiteoss.ecoflow.com/upload/image/1761269697844/highe_nergy_bills_uk.png"
                                alt={t`Say goodbye to high energy bills`}
                            />
                        </div>
                        <div className="video-box">
                            <EcoVideo pc="https://websiteoss.ecoflow.com/upload/video/1760680767257/uk_outPut.mp4" autoPlay className="fullImgs video" />
                        </div>
                        <div className="img-cover">
                            <EcoImg pc="https://websiteoss.ecoflow.com/upload/image/1768976632843/11_cover.png" alt={t`Say goodbye to high energy bills`} />
                        </div>
                    </div>
                </div>
            </div>
            <div className="h5">
                <div className="sticky">
                    <div className="left-box">
                        <div className="text-box">
                            <div className="text1">
                                <h2 className="title">{t('title1')}</h2>
                                <p className="desc">{t('desc1')}</p>
                            </div>
                        </div>
                        <div className="text-box">
                            <div className="text2">
                                <h2 className="title">{t('title2')}</h2>
                                <p className="desc">{t('desc2')}</p>
                            </div>
                        </div>
                    </div>
                    <div className="right-box">
                        <div className="img-box">
                            <EcoImg
                                pc="https://websiteoss.ecoflow.com/upload/image/1761271564838/highe_nergy_bills_uk_h5.png"
                                alt={t`Smart monitoring and control with ease`}
                            />
                        </div>
                        <div className="video-box">
                            <EcoVideo pc="https://websiteoss.ecoflow.com/upload/video/1760680767257/uk_outPut.mp4" className="fullImgs video" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
